import React from 'react'
import { useAtomValue } from 'jotai'

import { Access } from '../../lib'
import * as state from '../../states'
import { TRevenueSpendHistory } from '../../types'
import { IUiTableConfig, UiTable, UiDateInfo } from '../ui'
import * as helpers from '../../helpers'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueSpendHistoryListTableProps = {
	items: Array<TRevenueSpendHistory>;
	skip: number;
}

export const RevenueSpendHistoryListTable = (props: IRevenueSpendHistoryListTableProps) => {
	const {
		items = [],
		skip = 0
	} = props
	const { t } = useTranslation()
	const profile = useAtomValue(state.profileAtom)
	const $access = new Access(profile ?? null)

	const revenueSpendListTableConfig: IUiTableConfig<TRevenueSpendHistory>[] = [
		{
			key: 'agencyId',
			title: t(ALL_LANG_KEY.revenue_spend_list_table.column_agency_id)
		},
		{
			key: 'accountId',
			title: t(ALL_LANG_KEY.revenue_spend_list_table.column_account_id)
		},
		{
			key: 'at',
			title: t(ALL_LANG_KEY.revenue_spend_list_table.column_date),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value}/>
				)
			}
		},
		{
			key: 'updatedAt',
			title: t(ALL_LANG_KEY.revenue_spend_list_table.column_date_updated),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value}/>
				)
			}
		},
		{
			key: 'amount',
			title: t(ALL_LANG_KEY.revenue_spend_list_table.column_amount),
			rowCellFormatter: ({ value, rowData }) => {
				const formatValue = helpers.formatAmount(value)

				return <>{helpers.thousandSeparator(formatValue)}</>
			}
		}
	]

	return <>
		<UiTable
			data={items}
			config={revenueSpendListTableConfig}
			// TODO: uncomment if necessary
			// classesToAdd={{
			// 	wrapper: 'table-sticky-wrapper table-sticky-wrapper--top-60',
			// }}
		/>
	</>
}